import { useState } from 'react'


export default function useImageFallback(
  src: string,
  fallbackSrc: string
): string {
  const [imageSrc, setImageSrc] = useState(src)

  const image = new Image()
  image.src = imageSrc
  image.onload = () => {
    image.width < 480 && setImageSrc(fallbackSrc)
  }

  image.onerror = () => {
    setImageSrc(fallbackSrc)
  }

  return imageSrc
}